<td>
  <div class="flex gap-1 flex-column">
    <span class="flex gap-2 align-items-center"
      ><i
        class="w-1rem text-center"
        [class]="
          item.isSet ? 'fas fa-ruler-combined' : 'fas fa-ruler-vertical'
        "></i>
      {{ fullName ? indicatorStore.getFullName(item) : item.name }}

      @if (selectedIcon) {
        <span class="ml-auto">
          <i [class]="selectedIcon"></i>
        </span>
      }
    </span>
    <span class="flex gap-2 align-items-center text-color-secondary"
      ><i class="fas fa-folder w-1rem text-center"></i>
      {{ categoryStore.getPathById(item.category) }}</span
    >
  </div>

  @if (item.isSet) {
    @for (child of getChildren(item._id); track $index) {
      <div class="m-2 p-2">
        <i class="fas fa-ruler-vertical"></i> {{ child.name }}
      </div>
    }
  }
</td>
<td *ngIf="actions && actions.length" class="text-right">
  <span class="flex gap-2 justify-content-end"
    ><a
      *ngIf="actions.includes('info')"
      pButton
      class="p-button-xs"
      (click)="showInfo(item)"
      [rounded]="true"
      pTooltip="weitere Informationen"
      icon="fas fa-info-circle"></a>
    <p-button
      *ngIf="actions.includes('select')"
      styleClass="p-button-xs"
      (click)="select(item)"
      [rounded]="true"
      icon="fas fa-hand-pointer"></p-button>
    @if (activeUserStore.canAccessEntityAdder() && actions.includes('edit')) {
      <a
        pButton
        class="p-button-xs"
        (click)="closeParent()"
        [routerLink]="[
          { outlets: { bearbeiten: ['indikatoren', item._id, 'general'] } },
        ]"
        [rounded]="true"
        icon="fas fa-pen"></a>
    }
    <a
      *ngIf="actions.includes('addToAtlas')"
      pButton
      class="p-button-xs"
      (click)="addToAtlas(item)"
      [rounded]="true"
      pTooltip="Zum Atlas hinzufügen"
      icon="fas fa-laptop-file"></a>
    <a
      *ngIf="actions.includes('generateView')"
      pButton
      class="p-button-xs"
      (click)="generateView(item)"
      [rounded]="true"
      pTooltip="Im Atlas anzeigen"
      icon="fas fa-eye"></a>
    <a
      *ngIf="actions.includes('addToSelection')"
      pButton
      class="p-button-xs"
      (click)="addToSelection(item._id)"
      [rounded]="true"
      pTooltip="Der Auswahl hinzufügen"
      icon="fas fa-circle-plus"></a>
  </span>
</td>
